import { RootStore } from "./RootStore";
import { getLogs } from "../vendor";

export class AuditStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  public getLogs = async (
    limit?: number,
    offset?: number,
    where: {
      byUser?: string | null;
      period?: {
        dateInit: string | null;
        dateEnd: string | null;
      };
    } | null = null
  ) => {
    try {
      return await getLogs(limit, offset, where);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a lista de logs.",
        "error"
      );
      return null;
    }
  };
}
